module.exports = __webpack_public_path__ + "img/sEternalFi_193x205.6343fb41.png";